import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';

import { showModal } from '../actions/modal';
import { setAuthDetails } from '../actions/auth';

import { login } from '../services/onboarding-service';
import * as ElectronService from '../services/electron-service';
import { getUrlParams } from 'utils/index';

import TeamSelector from './team-selector';
import AppFeatured from './app-featured';
import Login from './login';
import LoginAdditionalAuth from './LoginAdditionalAuth';
import ForgottenPassword from './forgotten-password';
import HideInIframe from './HideInIframe';
import AuthDisabled from './AuthDisabled';

import niftyLogo from '../images/nifty-logo.svg';

class AuthFlow extends PureComponent {
    state = {
        stage: this.props.match?.params?.stage || 'login',
        email: '',
        teams: null,
        failedTeamUrl: null,
        teamSelectResolve: null,
        userName: null
    }

    handleForgottenPasswordClick = email => {
        this.setStage('forgottenPassword', email);
    }

    handleSignupClick = email => {
        this.props.history.push({
            pathname: '/signup/email',
            search:  (window.location && window.location.search),
            hash: `email=${email}`,
            state: {
                backUrl: '/login'
            }
        });
    }

    handleLoginSuccess = ({ email, password, provider, socialData }) => {
        const { redirect } = getUrlParams();

        return login({
            email,
            password,
            provider,
            socialData,
            redirect: redirect ? decodeURIComponent(redirect) : (window.location && window.location.pathname),
            chooseTeam: (masterToken, failedTeamUrl, teamTokens, userId, ssoLogin) => new Promise(resolve => {
                setAuthDetails({
                    masterToken
                });

                this.setState({
                    chooseTeam: true,
                    masterToken,
                    failedTeamUrl,
                    teamTokens,
                    userId,
                    ssoLogin,
                    teamSelectResolve: resolve
                });
            }),
            onAdditionalAuth: (additionalAuth) => {
                return new Promise(res => {
                    this.setStage('additionalAuth');
                    this.setState({ additionalAuth, email, password, additionalAuthSuccess: res });
                });
            }
        });
    }

    handleForgottenPasswordBackClick = () => {
        this.setStage('login');
    }

    handleForgottenPasswordSuccess = email => {
        this.setStage('login', email);
    }

    handleTeamClick = teamUrl => {
        this.state.teamSelectResolve(teamUrl);
    }

    handleNewTeamClick = () => {
        showModal('CREATE_TEAM');
    }

    setStage(stage, email) {
        this.setState({
            stage,
            email: email ? email : this.state.email
        });
    }

    componentDidMount() {
        ElectronService.emit('logout');
    }

    render() {
        return (
            <div className="app-main with-background">
                <div className="auth-flow">
                    <div className="auth-flow-inner">
                        <div className="auth-flow-head">
                            <a href="https://niftypm.com">
                                <img className="logo" src={niftyLogo} width="101px" alt="Nifty logo" />
                            </a>
                        </div>

                        <div className="auth-flow-main">
                            {
                                this.state.chooseTeam ? (
                                    <TeamSelector
                                        masterToken={this.state.masterToken}
                                        failedTeamUrl={this.state.failedTeamUrl}
                                        teamTokens={this.state.teamTokens}
                                        userId={this.state.userId}
                                        ssoLogin={this.state.ssoLogin}
                                        onTeamClick={this.handleTeamClick}
                                        onNewTeamClick={this.handleNewTeamClick}
                                    />
                                ) : (
                                    <React.Fragment>
                                        <AppFeatured />

                                        <HideInIframe>
                                            <div className="auth-flow-body">
                                                {
                                                    this.state.stage === 'login' ?

                                                    <Login
                                                        email={this.state.email}
                                                        onForgottenPasswordClick={this.handleForgottenPasswordClick}
                                                        onSignupClick={this.handleSignupClick}
                                                        onSuccess={this.handleLoginSuccess}
                                                    />

                                                    : this.state.stage === 'additionalAuth' ?

                                                    <LoginAdditionalAuth
                                                        additionalAuth={this.state.additionalAuth}
                                                        email={this.state.email}
                                                        password={this.state.password}
                                                        onSuccess={this.state.additionalAuthSuccess}
                                                    />

                                                    : this.state.stage === 'forgottenPassword' ?

                                                    <ForgottenPassword
                                                        email={this.state.email}
                                                        onBackClick={this.handleForgottenPasswordBackClick}
                                                        onSuccess={this.handleForgottenPasswordSuccess}
                                                    />

                                                    : null
                                                }
                                            </div>
                                        </HideInIframe>

                                        <HideInIframe reverse={true}>
                                            <div className="auth-flow-body">
                                                <AuthDisabled />
                                            </div>
                                        </HideInIframe>
                                    </React.Fragment>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(AuthFlow);
